// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cardTitle[data-v-a43975b0] {\n  padding: 0em 1em;\n  font-size: 0.875rem;\n  letter-spacing: 0.0892857143em;\n  text-transform: uppercase;\n  background: #fff;\n}", ""]);
// Exports
module.exports = exports;
